enum CreatorDashboardContext {
  Click = 'click',
  Hover = 'hover',
  Load = 'load',
}

export default CreatorDashboardContext;
